/**
 * @since 0.23.0
 * @visibleName DOC
 * @component
 */
export default {
  DOC_URL: 'https://react-platform.dev.livraisonti.ia.iafg.net/',
} as const;
